import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router } from '@angular/router';
import * as _ from 'lodash';

import { HttpService } from './http.service';
import { Subject } from 'rxjs/Subject';
import { NzModalService } from 'ng-zorro-antd';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class AuthService implements CanActivate {
    backUrl = '/home';
    myAuths = {};
    get isLoggedIn() {
        const token: string = sessionStorage.getItem('token') || '';
        return token.length;
    }

    get userInfo() {
        const userInfo = sessionStorage.getItem('userInfo');
        if (userInfo !== null) {
            try {
                return JSON.parse(userInfo);
            } catch (err) { }
        }
        return null;
    }

    loginSuccess$ = new Subject();
    constructor(
        private http: HttpService,
        private router: Router,
        private translate: TranslateService,
        private modal: NzModalService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.isLoggedIn) return true;
        const token: string = sessionStorage.getItem('token') || '';
        if (token.length === 0) {
            this.backUrl = this.getBackUrl(state.url);
            this.router.navigate(['login']);
            // const modals = this.modal.error(
            //     {
            //         title: this.translate.instant('common.authentication-error'),
            //         content: '用户未登录,无法执行该操作',
            //         onOk: () => {
            //             this.router.navigate(['login']);
            //         },
            //         onCancel: () => {
            //             this.router.navigate(['login']);
            //         }
            //     });
            // setTimeout(() => modals.destroy('onCancel'), 3000);
            return false;
        }
        return true;
    }

    private getBackUrl(url) {
        const index = url.indexOf('?');
        if (index >= 0) {
            return url.substring(0, index);
        } else {
            return url;
        }
    }

    checkLanguage(postbody) {
        return this.http.post('api/srm/checkLanguage', postbody)
            .switchMap(res => this.http.mapRes(res));
    }

    logout() {
        const onSubscribe = () => {
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('userInfo');
            sessionStorage.removeItem('ent');
            this.backUrl = 'home';
            this.router.navigate(['login']);
        };
        this.http.get('api/loginout', {}).subscribe(onSubscribe, onSubscribe, onSubscribe);
    }

    redirectAfterLogin(modifyPassword) {
        this.loginSuccess$.next(true);
        this.router.navigate([this.backUrl || '/home']);
        if (modifyPassword) {
            this.modal.confirm({
                title: this.translate.instant('common.warn'),
                content: '这是您的首次登录，为安全起见，强烈建议您修改密码，并妥善保管您的新密码',
                okText: '现在就去',
                cancelText: '以后再说',
                onOk: () => {
                    this.router.navigate(['/user/password']);
                }
            });
        }
    }

    setMyAuths(rows) {
        this.myAuths = {};
        if (_.isArray(rows)) {
            const arr = rows.map(x => x.permission);
            _.compact(arr).map(x => {
                this.myAuths[x] = true;
                return x;
            });
        }
        // console.log(this.myAuths);
    }

    hasPermission(key) {
        return this.myAuths && _.has(this.myAuths, key);
        // console.log(this.myAuths, key);
        // const res = this.myAuths && _.has(this.myAuths, key);
        // console.log(res);
        // return res;
    }
}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/core/services/auth.service.ts